import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { ProductService } from '../product-list.service';

@Component({
  selector: 'app-dd-download-popup',
  templateUrl: './dd-download-popup.component.html',
  styleUrls: ['./dd-download-popup.component.scss'],
})
export class DirectDealerDownloadPopupComponent implements OnInit {

  action = new Subject();
  message: string ="";
  data: any;
  passingData :string;
  userGroupOrder : any;
  pagename:any;
  
  constructor(public modalRef: MDBModalRef,private route: ActivatedRoute,private productService: ProductService, private modalService: MDBModalService) { }

  ngOnInit() {
   this.route.queryParamMap.subscribe(queryParams => {
    this.pagename = queryParams.get('page');
    console.log(this.pagename);
    this.getAllFiltersType(this.pagename)
  });
  }
  close() {
    
    this.action.next('OK');
    this.modalRef.hide()
  }
  
  
  successModalRef: MDBModalRef;
  waitingModalRef: MDBModalRef;
  optionSelected: string = "";
   
  onSelect(e) {
    this.optionSelected = e.target.value
   console.log("optionSelected",this.optionSelected);
   this.productService.SetName(this.optionSelected);
   
  }
  brandFilterDetails:any
  getAllFiltersType(filter): any {
    this.productService.getBrandBasedOnProductType(filter).then((data)=>{
      this.brandFilterDetails = data
    })
  
  }
  Array: string[] = [];
  isfrmChecked:any;
  componentMethodName(event: any, isChecked: boolean) 
  {
    if (isChecked) {
      this.Array.push(event.target.value)
    }
    else {
      let index = this.Array.indexOf(event.target.value);
      this.Array.splice(index, 1);
    }
    console.log(this.Array);
    this.productService.SetBrandNames(this.Array);
    
  }
  download() {
    console.log(this.Array);
    
    if(this.Array.length ==0){
      alert("Atleast Select one Brand")
      return false
      // 
    }else{
      this.action.next();
    }
    



  }

}
